var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PacemEventTarget, Watch, PropertyConverters, Utils } from './_default-imports';
import { avoidHandler } from '../../utils';
import { CustomEventUtils } from '../../utils-customevent';
//namespace Pacem.Components {
const KEYEVT = "keydown";
function matchesKeyCombination(evt, combo, accumulator = []) {
    if (Utils.isNullOrEmpty(combo)) {
        return false;
    }
    const modifierPattern = /(\w+)\s*\+/;
    const modifiers = [];
    let regExc;
    while (!Utils.isNullOrEmpty(regExc = modifierPattern.exec(combo))) {
        combo = combo.substr(regExc.index + regExc[0].length);
        modifiers.push(regExc[1]);
    }
    if (!CustomEventUtils.matchModifiers(evt, modifiers)) {
        return false;
    }
    const pieces = combo.split(',').map(p => p.trim().toLowerCase());
    if (Utils.isNullOrEmpty(pieces)) {
        // bad combination format
        return false;
    }
    var char = evt.key.toLowerCase();
    if (charEquals(char, pieces[accumulator.length])) {
        accumulator.push(char);
        return accumulator.length == pieces.length ? true : "ongoing";
    }
    return false;
}
function charEquals(key, piece) {
    return key === piece
        // adjust some aliases
        || (key === "escape" && piece === "esc")
        || (key === "backspace" && piece === "back")
        || (key === "control" && piece === "ctrl")
        || (key === "delete" && (piece === "del" || piece === "canc"))
        || (/^arrow/.test(key) && (piece === key.substr(5)));
}
export const KeyboardShortcutExecuteEventName = "execute";
let PacemShortcutElement = class PacemShortcutElement extends PacemEventTarget {
    constructor() {
        super(...arguments);
        this._accumulator = [];
        this._shortcutHandler = (evt) => {
            const result = (matchesKeyCombination(evt, this.combination, this._accumulator));
            switch (result) {
                case true:
                    avoidHandler(evt);
                    this.dispatchEvent(new Event(KeyboardShortcutExecuteEventName, { bubbles: false, cancelable: false }));
                // let flow below...
                case false:
                    this._accumulator.splice(0);
                    break;
            }
        };
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._addHandler();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'target' && !first) {
            this._removeHandler(old);
            this._addHandler(val);
        }
    }
    disconnectedCallback() {
        this._removeHandler();
        super.disconnectedCallback();
    }
    _removeHandler(target = this.target) {
        (target || window).removeEventListener(KEYEVT, this._shortcutHandler, false);
    }
    _addHandler(target = this.target) {
        (target || window).addEventListener(KEYEVT, this._shortcutHandler, false);
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemShortcutElement.prototype, "combination", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Element })
], PacemShortcutElement.prototype, "target", void 0);
PacemShortcutElement = __decorate([
    CustomElement({ tagName: P + '-shortcut' })
], PacemShortcutElement);
export { PacemShortcutElement };
;
//}
